<template>
<div>
  <div class="app-tab-navigation">
      <div class="app-tab-navigation__breadcrumbs">
          <a class="app-tab-navigation__breadcrumb" :href="`/clients/${project.client.id}`">
          <svg class="element-icon--breadcrumb element-icon" width="1em" height="1em" title=""><use href="/img/icons.svg#icon-breadcrumb"></use></svg>
          {{ project.client.name }}
          </a>
          <svg class="element-icon--chevron-right element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-chevron-right"></use></svg>
          <a class="app-tab-navigation__breadcrumb" :href="`/projects/${project.id}/courses`">
          <svg class="element-icon--breadcrumb element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-breadcrumb"></use></svg>
          {{ project.name }}
          </a>
      </div>
      <h1 class="app-tab-navigation__title">Golden Source</h1>
      <ul class="app-tab-navigation__nav">
          <li v-if="item.completed_at">
              <a :href="`/project-sources/${item.id}/review`">Repository</a>
          </li>
          <li v-if="item.completed_at">
              <a :href="`/project-sources/${item.id}/images`">Images</a>
          </li>
          <li class="is--active">
              <a :href="`/projects/${project.id}/sources/${item.id}`">Source Documents</a>
          </li>
      </ul>
  </div>

  <div v-if="showConfirmation" class="app-modal-dialog--confirm-document-analysis app-modal-dialog">
    <div class="app-modal-dialog__content">
        <div class="app-modal-dialog__header">
            <h2 class="app-modal-dialog__title">
                <span class="app-modal-dialog__title">Confirm Document Analysis Initiation</span>
            </h2>
        </div>
      <div class="app-modal-dialog__body">
          <p>This process may take several hours, and while the analysis is underway, <strong>you and any other project members cannot create, modify, or delete courses.</strong></p>
          <br>
          <p>You and any other project members will receive an email when analysis is complete.</p>
          <template v-if="source.completed_at">
            <br>
            <div class="inline-message is--warning">
              <div>
                <p>Warning: You have already generated your Golden Source. Submitting documents for analysis again will recreate the Golden Source.</p>
                <br>
                <div class="input checkbox">
                  <input v-model="appendMode" type="checkbox" id="append-mode" class="checkbox__input" name="appendMode">
                  <label for="append-mode">Select to add the new document(s) to the existing Golden Source, rather than creating a new Golden Source.</label>
                </div>
              </div>
            </div>
          </template>
      </div>
      <div class="app-modal-dialog__footer">
        <app-button theme="secondary"
          type="submit"
          class=""
          @click="showConfirmation = false">
          {{ 'Cancel' }}
        </app-button>
        <app-button theme="primary"
          type="submit"
          class=""
          :disabled="disabled || !prerequisitesMet"
          @click="submit()">
          {{ disabled ? 'Processing...' : 'Confirm' }}
        </app-button>
      </div>
    </div>
  </div>
  <div class="app-project-sources-upload page-main">
    <div class="page-main__content">
      <div class="page-main__section">
        <div class="page-main__section-header">
          <h2 class="page-main__title">Golden Source Documents</h2>
          <app-button theme="ai-primary"
            type="submit"
            class=""
            :disabled="disabled || !prerequisitesMet"
            @click="showConfirmation = true">
            <svg class="element-icon--ai element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-ai"></use></svg>
            {{ disabled ? 'Processing...' : 'Submit Documents For Analysis' }}
          </app-button>
        </div>
        <app-error
          v-if="hasErrors"
          class="is--inline"
          v-bind="errors" />
        <asset-manager-lite class="app-project-sources-upload__section-body" ref="manager"
          :source="assetSource"
          :files="assetFiles"
          :valid-extensions="validExtensions"
          :valid-mime-types="validMimeTypes"
          :type-dropdown=false
          :process-images=true
          :max-file-size="maxFileSize">
        </asset-manager-lite>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import api from '../api/ai'
import AssetManager from './AssetManager.vue'

export default {
  components: { AssetManager },
  props: {
    project: {
      type: Object,
    },
    item: {
      type: Object,
    },
    aiEnabled: {
      type: [Boolean, Number],
      default: false
    },
    assetFiles: {
      type: Array
    },
    assetSource: {
      type: String,
    },
    validExtensions: {
      type: Object,
      default: () => { "document" }
    },
    validMimeTypes: {
      type: Object,
      default: () => ({})
    },
    maxFileSize: {
      type: Number,
      default: (50 * 1024 * 1024) // 50MB
    }
  },
  data() {
    return {
      source: this.item || {},
      disabled: false,
      showConfirmation: false,
      appendMode: false,
      errorMessage: null,
      errors: []
    }
  },
  computed: {
    hasErrors () {
      return this.errorMessage || (this.errors?.message ?? this.errors?.errors?.message)
    },
    ...mapGetters('assets', {
      allFiles: 'fileSet',
    }),
    prerequisitesMet () {
      return this.allFiles?.length > 0
    },
  },
  methods: {
    async submit() {
      this.disabled = true

      const params = {
        appendMode: this.appendMode
      }

      // api call to begin document ingestion process
      const result = await api.processGoldenSource(this.source.project_id, this.source.id, params)

      if (result.errors) {
        // catch errors
        this.disabled = false
        this.errors = result.errors
        this.errorMessage = result.message
      } else {
        // redirect
        window.location.href = '/projects/' + this.project.id + '/courses';
      }
    }
  },
  created() {

  }
}
</script>
